import {Address} from '../model/address';

export class AddressFormatService {

  public formatToSingleLine(address: Address, includeCountry: boolean): string {
    return AddressFormatService.format(address, ', ', includeCountry, ', ');
  }

  public formatToMultiline(address: Address, includeCountry: boolean): string {
    return AddressFormatService.format(address, '\r\n', includeCountry, '\r\n');
  }

  private static format(address: Address, firstLineDelimiter: string, includeCountry: boolean, secondAddressLineDelimiter: string = '',
                 forcedCountry: string = ''): string {
    let result = '';
    if (this.isNotNullOrEmpty(address)) {
      const firstLine: string = this.createFirstLine(address, forcedCountry);
      const secondLine: string = this.createSecondLine(address, forcedCountry);
      if (this.isNotNullOrEmpty(firstLine) && this.isNotNullOrEmpty(secondLine)) {
        result = result.concat(firstLine, firstLineDelimiter, secondLine);
      } else if (!this.isNotNullOrEmpty(firstLine)) {
        result = result.concat(secondLine);
      } else if (!this.isNotNullOrEmpty(secondLine)) {
        result = result.concat(firstLine);
      }
      if (includeCountry) {
        const country: string = this.isNotNullOrEmpty(forcedCountry) ? forcedCountry : address.country;
        if (this.isNotNullOrEmpty(result)) {
          result = result.concat(secondAddressLineDelimiter, country);
        } else {
          result = result.concat(country);
        }
      }
    }
    return result;
  }

  public static createFirstLine(address: Address, forcedCountry: string): string {
    let result = '';
    let houseNumberPart = address.houseNumber != null ? address.houseNumber.toString() : '';
    if (this.isNotNullOrEmpty(address.houseNumberExtension)) {
      if (this.isNotNullOrEmpty(address.houseNumber)) {
        houseNumberPart += '/';
      }
      houseNumberPart += address.houseNumberExtension;
    }
    if (this.isNotNullOrEmpty(address.mailBox)) {
      if (this.isNotNullOrEmpty(houseNumberPart)) {
        houseNumberPart += '/';
      }
      houseNumberPart += address.mailBox;
    }
    const country = this.isNotNullOrEmpty(forcedCountry) ? forcedCountry : address.country;
    switch (country) {
      case 'FR':
      case 'US':
      case 'GB':
        // [housenumber]/[housenumberextension]/[mailbox] [street]
        result = (this.isNotNullOrEmpty(address.street)) ? houseNumberPart + ' ' + address.street : houseNumberPart;
        break;
      default:
        // [street] [housenumber]/[housenumberextension]/[mailbox]
        result = (this.isNotNullOrEmpty(address.street)) ?  address.street + ' ' + houseNumberPart : houseNumberPart;
        break;
    }
    return result;
  }

  public static createSecondLine(address: Address, forcedCountry: string): string {
    let result = '';
    const country = this.isNotNullOrEmpty(forcedCountry) ? forcedCountry : address.country;
    switch (country) {
      case 'US':
      case 'GB':
        // [City] [ZipCode]
        result = this.isNotNullOrEmpty(address.city) ? address.city : '';
        if (this.isNotNullOrEmpty(address.zipCode)) {
          result += this.isNotNullOrEmpty(address.city) ? ' ' + address.zipCode : address.zipCode;
        }
        break;
      default:
        // [ZipCode] [City]
        result = this.isNotNullOrEmpty(address.zipCode) ? address.zipCode : '';
        if (this.isNotNullOrEmpty(address.city)) {
          result += this.isNotNullOrEmpty(address.zipCode) ? ' ' + address.city : address.city;
        }
        break;
    }
    return result;
  }

  private static isNotNullOrEmpty(value: any): boolean {
    return value != null && value !== '';
  }
}
